module.exports = "\n  .img-responsive {\n    display: inline-block;\n  }\n\n.bannerColor{\n  background-color:black;\n  width: 100%;\n  height: auto;\n}\n"